import React, { ReactNode } from 'react';

import classes from './InfoCardTitle.module.scss';
import { IconBackgroundWrapper } from '../../../../../shared/components/ui-components';

type WidgetTitleProps = {
  title: string;
  icon: ReactNode;
};

const InfoCardTitle = ({ title, icon }: WidgetTitleProps) => {
  return (
    <div className={classes.container}>
      <p className={classes.titleText}>{title}</p>
      <IconBackgroundWrapper icon={icon} />
    </div>
  );
};

export { InfoCardTitle };
